import { type ManualOfferBuyerType, type ManualOfferClientType, type ManualOfferDocumentType, type ManualViewingStatus } from './manualOperations.types'
import { type ManualAdvertisementPortal, type ManualAdvertisementStatus } from './manualAdvertisement.types'

export const manualActionUserConfig = {
    id: Number(process.env.REACT_APP_BSO_MANUAL_ACTION_USER_ID),
    email: process.env.REACT_APP_BSO_MANUAL_ACTION_USER_EMAIL ?? ''
}

export const isManualActionUserConfigured = (): boolean =>
    Number.isFinite(manualActionUserConfig.id) && manualActionUserConfig.id > 0

export const MANUAL_VIEWING_STATUS_OPTIONS: ManualViewingStatus[] = [
    'Completed',
    'In-process',
    'Approved',
    'Confirmed',
    'Waiting for feedback',
    'Waiting for complain',
    'Rescheduled by BSO',
    'Rescheduled by agent',
    'Rescheduled by other agent',
    'Rescheduled by landlord',
    'Canceled',
    'Canceled by BSO',
    'Canceled by agent',
    'Canceled by other agent',
    'Rejected'
]

export const DEFAULT_MANUAL_VIEWING_STATUS: ManualViewingStatus = 'Completed'

export const DEFAULT_MANUAL_OFFER_STATUS = 'Completed' as const

export const MANUAL_OFFER_CLIENT_TYPES: ManualOfferClientType[] = ['Individual', 'Company']
export const MANUAL_OFFER_DOCUMENT_TYPES: ManualOfferDocumentType[] = ['emirates-id', 'passport', 'both']
export const MANUAL_OFFER_BUYER_TYPES: ManualOfferBuyerType[] = ['Cash Buyer', 'Mortgage Buyer']
export const MANUAL_OFFER_PAYMENT_OPTIONS = ['1', '2', '3', '4', '6', '12']
export const MANUAL_OFFER_DURATION_OPTIONS = Array.from({ length: 19 }, (_, index) => String(index + 6))
export const MANUAL_OFFER_OCCUPANT_OPTIONS = ['Single', 'Couple', 'Family']
export const MANUAL_OFFER_YES_NO_OPTIONS = ['Yes', 'No'] as const
export const MANUAL_OFFER_PURCHASE_REASONS = ['Personal use', 'Investment'] as const

export const MANUAL_ADVERTISEMENT_STATUS_OPTIONS: ManualAdvertisementStatus[] = [
    'Advertisement closed',
    'Completed',
    'Advertisement started',
    'Links approved',
    'Links added',
    'Confirmed',
    'In-process'
]

export const DEFAULT_MANUAL_ADVERTISEMENT_STATUS: ManualAdvertisementStatus = 'Advertisement closed'

export const MANUAL_ADVERTISEMENT_PORTAL_OPTIONS: ManualAdvertisementPortal[] = [
    'Dubizzle',
    'Bayut',
    'Property Finder',
    'Other'
]
